(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["as-seen-on"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const track = document.getElementById("logoMarqueeTrack");
  const speed = 0.25; // pixels per frame, slow & steady
  let position = 0;

  // Duplicate logos until track width is at least 2x viewport
  const logos = Array.from(track.children);
  while (track.scrollWidth < window.innerWidth * 4) {
    logos.forEach(logo => {
      const clone = logo.cloneNode(true);
      track.appendChild(clone);
    });
  }

  function step() {
    position -= speed;
    if (position <= -track.children[0].offsetWidth - parseInt(getComputedStyle(track.children[0]).marginRight)) {
      // Move first logo to end
      const firstLogo = track.children[0];
      const moveDistance = firstLogo.offsetWidth + parseInt(getComputedStyle(firstLogo).marginRight);

      track.appendChild(firstLogo);
      position += moveDistance;
    }
    track.style.transform = `translateX(${position}px)`;
    requestAnimationFrame(step);
  }

  requestAnimationFrame(step);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["burger-tips-carousel"]) return;
  try {
    
    // Grilling Tips
    // Array of text options
    const grillingTips = [
    "Tip #1 - Season Generously: Before grilling, season your burgers generously with salt and pepper. If you like, you can also add other seasonings like garlic powder or onion powder for extra flavor.",
    "Tip #2 - Preheat the Grill: Before you start cooking, preheat your grill to high heat. This will ensure that the burgers cook quickly and develop a nice crust.",
    "Tip #3 - Don't Press Down on the Burgers: As the burgers cook, resist the urge to press down on them with a spatula. This will only release the flavorful juices and can dry out the burgers. ",
    "Tip #4 - Cook to the Right Temperature: Use a meat thermometer to ensure that your burgers are cooked to the right temperature. For beef burgers, the safe internal temperature is 160°F.",
    "Tip #5 - Rest the Burgers: After taking the burgers off the grill, let them rest for a few minutes before serving. This will allow the juices to redistribute throughout the meat, making for a juicier burger."
    ];

    let currentIndex = 0;
    const textDisplay = document.querySelector(".tip-text");
    const leftArrow = document.querySelector(".arrow-icon-left");
    const rightArrow = document.querySelector(".arrow-icon-right");

    textDisplay.textContent = grillingTips[currentIndex];

    leftArrow.addEventListener("click", () => {
        currentIndex = (currentIndex - 1 + grillingTips.length) % grillingTips.length;
        textDisplay.textContent = grillingTips[currentIndex];
    });

    rightArrow.addEventListener("click", () => {
        currentIndex = (currentIndex + 1) % grillingTips.length;
        textDisplay.textContent = grillingTips[currentIndex];
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["butcher-burger-recipes"]) return;
  try {
    
   // Generate Recipes and Pagination
    const recipeArray = [
        {
            name: "All-American",
            ingredients: "Fried Pickles, American Cheese, Relish & Chips"
        },
        {
            name: "Alpine",
            ingredients: "Covered with Sautéed Mushrooms & Swiss Cheese"
        },
        {
            name: "Anchovy",
            ingredients: "Stuffed with Anchovies, Mozzarella & Pizza Sauce"
        },
        {
            name: "Aphrodisiac",
            ingredients: "Stuffed with Oysters & Dressed with Steak Sauce"
        },
        {
            name: "Au Poivre",
            ingredients: "Topped with Bleu Cheese, Parsley & Mozzarella"
        },
        {
            name: "Bacon Cheddar",
            ingredients: "Bacon, Cheddar, Onion Strings & BBQ Sauce"
        },
        {
            name: "Bacon Jam",
            ingredients: "Goat Cheese, Bacon Jam & Caramelized Onions"
        },
        {
            name: "Bagel",
            ingredients: "Onion & Tomato, then Served with Cream Cheese"
        },
        {
            name: "Bao-Wow",
            ingredients: "Chili with Soy-Ginger Mayo & Asian Slaw"
        },
        {
            name: "Barbecue",
            ingredients: "Tangy Barbecue Sauce & Hot Peppers"
        },
        {
            name: "Basic",
            ingredients: "Seasoned with Salt & Pepper"
        },
        {
            name: "Beany",
            ingredients: "Cajun Seasoned, then Topped with Pork & Beans"
        },
        {
            name: "Beef LT",
            ingredients: "Crispy Bacon, Lettuce, Tomato & Mayo"
        },
        {
            name: "Beefster",
            ingredients: "Topped with Roast Beef, Horseradish & Muenster"
        },
        {
            name: "Big Island",
            ingredients: "Mozzarella, Bacon & Pineapple"
        },
        {
            name: "Billy",
            ingredients: "Ketchup Only, then Cut in Half to Eat"
        },
        {
            name: "Bistro",
            ingredients: "Onions, Brie Cheese & Crispy Bacon"
        },
        {
            name: "Black Jack",
            ingredients: "Jack Cheese, Mayo, Onions & Tomatoes"
        },
        {
            name: "Bleu Cheese",
            ingredients: "Crumbled Bleu Cheese & Bacon"
        },
        {
            name: "Blue Bayou",
            ingredients: "Bleu Cheese, Lettuce, Tomatoes & Hot Pepper Mayo"
        },
        {
            name: "Blue Moon",
            ingredients: "Blue Cheese, Lettuce, Tomato & Sautéed Mushrooms"
        },
        {
            name: "Breakfast",
            ingredients: "Diced Ham, Cheddar, Mushrooms & Green Peppers"
        },
        {
            name: "Brie",
            ingredients: "Warm Brie, Granny Smith Apples & Spicy Mustard"
        },
        {
            name: "Brocco",
            ingredients: "Melted Cheddar Cheese & Cooked Broccoli"
        },
        {
            name: "Bruschetta",
            ingredients: "Italian-Seasoned, Topped with Fresh Basil & Tomato"
        },
        {
            name: "Burger Al Forno",
            ingredients: "Italian-Seasoned, Topped with Garlic & Rosemary"
        },
        {
            name: "Caesar",
            ingredients: "Caesar Dressing, Avocado & Romaine Lettuce"
        },
        {
            name: "Cajun",
            ingredients: "Jalapeño Cheese, Chili Mayo & Pico de Gallo Sauce"
        },
        {
            name: "California",
            ingredients: "Chopped Walnuts, Garlic & Guacamole"
        },
        {
            name: "Capri",
            ingredients: "Smoked Mozzarella, Parmesan Flakes & Crispy Prosciutto"
        },
        {
            name: "Cheesy Pizza",
            ingredients: "Pizza Sauce, Provolone, Cheddar & Mozzarella"
        },
        {
            name: "Chicago",
            ingredients: "Sweet Relish, Onions, Ketchup, Mustard & Peppers"
        },
        {
            name: "Chili",
            ingredients: "Covered in Chili and Shredded Cheese"
        },
        {
            name: "Chili Con Queso",
            ingredients: "Chili and Melted Jalapeño Cheese Sauce"
        },
        {
            name: "Classic",
            ingredients: "Ketchup, Mustard & Pickles"
        },
        {
            name: "Cordon Bleu",
            ingredients: "Sliced Ham, Swiss cheese & Dijon Mustard"
        },
        {
            name: "Corny",
            ingredients: "Tangy Corn Relish"
        },
        {
            name: "Cowboy",
            ingredients: "Grilled Mushrooms, Monterey Jack, Bacon & Onions"
        },
        {
            name: "Crabby",
            ingredients: "Shredded Crabmeat and Swiss cheese"
        },
        {
            name: "Dieter's",
            ingredients: "Low-Fat Cottage Cheese & No Bun"
        },
        {
            name: "Dilly",
            ingredients: "Fresh Dill, Onions, Mushrooms & Provolone"
        },
        {
            name: "Double Decker",
            ingredients: "Cheddar & Pizza Sauce Between Two Burgers"
        },
        {
            name: "Dragon",
            ingredients: "Limburger Cheese & Raw Onions"
        },
        {
            name: "Earth & Turf",
            ingredients: "Porcini Mushroom Sauce, Bell Peppers & Zucchini"
        },
        {
            name: "Egg",
            ingredients: "Fried or Scrambled Eggs"
        },
        {
            name: "Fajita",
            ingredients: "Guacamole, Sour Cream, Lettuce, Salsa & Tomatoes"
        },
        {
            name: "Feelin' Blue",
            ingredients: "Blue Cheese, Bacon Jam, Arugula & Onion Strings"
        },
        {
            name: "Five-Spice",
            ingredients: "Chinese five-spice with a Soy-Ginger Sauce"
        },
        {
            name: "Flank Steak",
            ingredients: "Cayenne Flank Steak & Black Bean Chili"
        },
        {
            name: "French Bistro",
            ingredients: "Walnuts, Gruyere Cheese & Garlic Mustard Mayo"
        },
        {
            name: "French Dip",
            ingredients: "Provolone, Onion Strings, Horseradish Cream & Au Jus"
        },
        {
            name: "Garden-Fresh",
            ingredients: "Onions, Beets, Potatoes & Sour Cream"
        },
        {
            name: "Garlic",
            ingredients: "Garlic, Cheese & Garlic Mayo"
        },
        {
            name: "German",
            ingredients: "Aged Cheddar & Dusseldorf Mustard"
        },
        {
            name: "Ginger-Island",
            ingredients: "Soy Sauce, Ginger, Cilantro & Sesame Oil"
        },
        {
            name: "Good Morning",
            ingredients: "Bacon, Fried Egg, Tater Tots & American Cheese"
        },
        {
            name: "Gorgonzola",
            ingredients: "Gorgonzola & Sweet Mustard"
        },
        {
            name: "Gouda",
            ingredients: "Grilled Zucchini Slices & Gouda Cheese"
        },
        {
            name: "Greek",
            ingredients: "Feta, Black Olives & Onions"
        },
        {
            name: "Guac",
            ingredients: "Pepperjack Cheese, Guacamole, Pico de Gallo & Queso"
        },
        {
            name: "Gyro",
            ingredients: "Onions, Tomatoes & Yogurt Cucumber Dressing"
        },
        {
            name: "Hawaiian",
            ingredients: "Topped with Crushed Pineapple & Sweet and Sour Sauce"
        },
        {
            name: "Hickory",
            ingredients: "Cheddar, Bacon & Hickory Barbecue Sauce"
        },
        {
            name: "Horsey",
            ingredients: "Cheddar, Caramelized Grilled Onions & Horseradish Mayo"
        },
        {
            name: "Islander",
            ingredients: "Lettuce, Tomato, Pickles & Thousand Island Dressing"
        },
        {
            name: "Jalapeño",
            ingredients: "Hot Sauce, Jalapeños & Cheddar"
        },
        {
            name: "Kalamata",
            ingredients: "Chopped Greens, Olives & Cream Cheese"
        },
        {
            name: "Lucky",
            ingredients: "Mustard, Horseradish, Cheddar, Apples & Almonds"
        },
        {
            name: "Maui Wowwie",
            ingredients: "Swiss, Grilled Pineapple, Ham & Sriracha Mayo"
        },
        {
            name: "Meant to Brie",
            ingredients: "Brie, Garlic Sautéed Mushrooms & Truffle Aioli"
        },
        {
            name: "Mediterranean",
            ingredients: "Mediterranean Spices & Gyro Sauce"
        },
        {
            name: "Milanese",
            ingredients: "Breadcrumbs, Oregano & Parmesan Cheese"
        },
        {
            name: "North Woods",
            ingredients: "Wild Mushroom Sauce & Bell Peppers"
        },
        {
            name: "Olive Festival",
            ingredients: "Sliced Black & Green Olives"
        },
        {
            name: "Onion",
            ingredients: "Dried Onion Soup Mix & Raw Onions"
        },
        {
            name: "Outback",
            ingredients: "Tender Cactus, Green Salsa & Spicy Pepper Cheese"
        },
        {
            name: "Paradise",
            ingredients: "Melted Brick Cheese, Pineapple & Coconut"
        },
        {
            name: "Parisian",
            ingredients: "Crumbed Bleu Cheese, Red Onions & Tomatoes"
        },
        {
            name: "PB&B",
            ingredients: "Peanut Butter, Bacon, American Cheese & Jelly"
        },
        {
            name: "Peking",
            ingredients: "Peking Marinade & Mixed Greens"
        },
        {
            name: "Pepperific",
            ingredients: "Jalapeño, Relish, Pepper Jack & Steak Sauce"
        },
        {
            name: "Pepperoni",
            ingredients: "Pepperoni, Mozzarella & Pizza Sauce"
        },
        {
            name: "Pesto",
            ingredients: "Pesto Sauce, Cooked Spinach & Mozzarella"
        },
        {
            name: "Pineapple",
            ingredients: "Grilled Pineapple & Smoked Gruyere Cheese"
        },
        {
            name: "Pinwheel",
            ingredients: "Melted & Quartered Cheese in a Pinwheel Design"
        },
        {
            name: "Pita Pizza",
            ingredients: "Melted Italian Cheese & Herb Tomato Sauce"
        },
        {
            name: "Potato Chip",
            ingredients: "Potato Chips, Ketchup & Mustard"
        },
        {
            name: "Provolone",
            ingredients: "Provolone Cheese, Tomatoes & Black Olives"
        },
        {
            name: "Ranch-Hand",
            ingredients: "Pinto Beans, Bacon, Chilies & Cheddar Cheese"
        },
        {
            name: "Santa Fe",
            ingredients: "Chili Puree, Bean Dip, Guacamole & Sour Cream"
        },
        {
            name: "Scandinavian",
            ingredients: "Gruyere, Cheddar, Lettuce, Cucumber & Onion"
        },
        {
            name: "Shrimpy",
            ingredients: "Cream Cheese, Cocktail Sauce & Chopped Shrimp"
        },
        {
            name: "Shroom Lover",
            ingredients: "Sautéed Mushrooms, Swiss, Bacon Bits & Mayo"
        },
        {
            name: "Shroomy",
            ingredients: "Gorgonzola & Sautéed Cremini Mushrooms"
        },
        {
            name: "Simple",
            ingredients: "Layered with your Choice of Wisconsin Cheeses"
        },
        {
            name: "Simple Twist",
            ingredients: "Tomato & Grated Asiago Cheeses"
        },
        {
            name: "Smoky",
            ingredients: "Roasted Balsamic Onions, Bacon & Smoked Cheese"
        },
        {
            name: "Spicy",
            ingredients: "Melted Jack Cheese, Jalapeño Peppers & Onions"
        },
        {
            name: "Steakhouse",
            ingredients: "Gruyere, Caramelized Onions, Rosemary & Aioli"
        },
        {
            name: "Steakhouse Bacon",
            ingredients: "Bacon, Smoked Gouda & Onion Rings"
        },
        {
            name: "Sticky",
            ingredients: "Peanut Butter, Bacon & Jack Cheese"
        },
        {
            name: "Stroganoff",
            ingredients: "Sour Cream, Onions, Swiss, Lettuce & Tomato"
        },
        {
            name: "Sunshine",
            ingredients: "Avocado, Scallions, Sprouts & Cheddar"
        },
        {
            name: "Taco",
            ingredients: "Shredded Lettuce, Tomato, Sour Cream & Black Olives"
        },
        {
            name: "Texas Red",
            ingredients: "Chili, Cheddar, Monterey Jack & Grilled Onions"
        },
        {
            name: "Tex-Mex",
            ingredients: "Onions, Crispy Bacon & Creamy Guacamole"
        },
        {
            name: "Thai-Cobb",
            ingredients: "Avocado, Tomatoes, Bean Sprouts & Peanut Dressing"
        },
        {
            name: "The David",
            ingredients: "Mac 'n Cheese & Melted American Cheese"
        },
        {
            name: "The Hangover",
            ingredients: "Cheddar, Onions, Fried Egg & Bacon"
        },
        {
            name: "Tortilla",
            ingredients: "Onion, Tomato, Parmesan & Mozzarella Cheeses"
        },
        {
            name: "Tough Texan",
            ingredients: "Hot Sauce, Pepper Cheese & Barbecue Sauce"
        },
        {
            name: "Trattoria",
            ingredients: "Red Bell Peppers, Pesto Mayo & Mozzarella"
        },
        {
            name: "Truffle",
            ingredients: "Truffle Aioli, Aged Swiss & Bacon-Tomato Jam"
        },
        {
            name: "Veg-Head",
            ingredients: "Cucumber, Tomatoes, Sprouts & Dill Dressing"
        },
        {
            name: "Verde",
            ingredients: "Garlic & Italian Verde Sauce"
        },
        {
            name: "Walla Walla",
            ingredients: "Pan Fried in a Sweet & Sour Chutney"
        },
        {
            name: "West Indies",
            ingredients: "Cilantro, Garlic, Lime, Curry Powder & Hot Sauce"
        },
        {
            name: "Worcestershire",
            ingredients: "Mushrooms Sautéed in Worcestershire Sauce"
        }
    ];

    let itemsPerPage = 12;
    let currentPage = 1;
    let currentRecipes = [];
    let activeLink = null;

    const searchInput = document.getElementById("search-input");
    const listContainer = document.getElementById("recipeList");
    const paginationContainer = document.getElementById("pagination");

    // Search function
    function searchRecipes() {
      const searchValue = searchInput.value.toLowerCase();

      // Filter recipes based on search value
      currentRecipes = recipeArray.filter(recipe => {
        const nameMatch = recipe.name.toLowerCase().includes(searchValue);
        const ingredientsMatch = recipe.ingredients.toLowerCase().includes(searchValue);
        return nameMatch || ingredientsMatch;
      });

      currentPage = 1;
      displayRecipes(currentPage);
      generatePaginationLinks();
    }

    // Display a specific page of recipes
    function displayRecipes(pageNumber) {
    listContainer.innerHTML = "";

    const startIndex = (pageNumber - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const recipes = currentRecipes.slice(startIndex, endIndex);

    if (recipes.length === 0) {
        const noResultsDiv = document.createElement("div");
        noResultsDiv.className = "no-results";
        noResultsDiv.textContent = "No results found.";
        listContainer.appendChild(noResultsDiv);
    } else {
        recipes.forEach(recipe => {
        const div = document.createElement("div");
        div.className = "list-group-item";
        div.innerHTML = `<h3>${recipe.name}</h3><p>${recipe.ingredients}</p>`;
        listContainer.appendChild(div);
        });
    }
    }

    // Generate pagination links
    function generatePaginationLinks() {
      paginationContainer.innerHTML = "";

      const totalPages = Math.ceil(currentRecipes.length / itemsPerPage);

      for (let i = 1; i <= totalPages; i++) {
        const link = document.createElement("a");
        link.href = "#";
        link.textContent = i;
        link.className = "pagination-link"; // Add pagination-link class to the link

        if (i === currentPage) {
          link.classList.add("active"); // Add active class to the current page link
          activeLink = link; // Update the reference to the active link
        }

        link.addEventListener("click", event => {
          event.preventDefault(); // Prevent default anchor behavior

          if (activeLink) {
            activeLink.classList.remove("active"); // Remove active class from the previously active link
          }

          currentPage = i;
          displayRecipes(currentPage);
          link.classList.add("active"); // Add active class to the clicked link
          activeLink = link; // Update the reference to the active link
        });

        paginationContainer.appendChild(link);
      }
    }
    // Search input event listener
    searchInput.addEventListener("input", searchRecipes);

    // Initial display
    currentRecipes = recipeArray.slice(); // Copy all recipes initially
    displayRecipes(currentPage);
    generatePaginationLinks();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["knife-logo-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const trackRight = document.getElementById("logoMarqueeTrackRight");
  const speedRight = 0.25;
  let positionRight = 0;

  const logosRight = Array.from(trackRight.children);
  while (trackRight.scrollWidth < window.innerWidth * 4) {
    logosRight.forEach(logo => {
      const clone = logo.cloneNode(true);
      trackRight.appendChild(clone);
    });
  }

  function stepRight() {
    positionRight += speedRight;

    const lastLogo = trackRight.children[trackRight.children.length - 1];
    const moveDistance = lastLogo.offsetWidth + parseInt(getComputedStyle(lastLogo).marginRight);

    if (positionRight >= moveDistance) {
      trackRight.insertBefore(lastLogo, trackRight.firstChild);
      positionRight -= moveDistance;
    }

    trackRight.style.transform = `translateX(${positionRight}px)`;
    requestAnimationFrame(stepRight);
  }

  requestAnimationFrame(stepRight);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-scroll"] && !Shopify.designMode) return;
  try {
    

const logoUrls = [
  "https://cdn.shopify.com/s/files/1/0071/9519/7491/files/logos-real-simple.png?v=1686083296",
  "https://cdn.shopify.com/s/files/1/0071/9519/7491/files/logos-cnn.png?v=1686083296",
  "https://cdn.shopify.com/s/files/1/0071/9519/7491/files/logos-rolling-stone.png?v=1686083296",
  "https://cdn.shopify.com/s/files/1/0071/9519/7491/files/logos-gma.png?v=1686083296"
];

const logoContainer = document.getElementById("logoContainer");

for (let i = 0; i < 4; i++) {
  logoUrls.forEach(url => {
    const logoImage = document.createElement("img");
    logoImage.classList.add("logo");
    logoImage.src = url;
    logoContainer.appendChild(logoImage);
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-v1"] && !Shopify.designMode) return;
  try {
    
// Logo Horizontal Scroll

const scrollFlex = document.querySelectorAll('.scroll-flex');
let lastKnownScrollPosition = 0;
let ticking = false;

function scrollFunction() {
    for (let i = 0; i < scrollFlex.length; i++) {
        scrollFlex[i].style.transform = `translateX(${lastKnownScrollPosition * -.5}px)`;
    }
}

document.addEventListener("scroll", (event) => {
  lastKnownScrollPosition = window.scrollY;

  if (!ticking) {
    window.requestAnimationFrame(() => {
      scrollFunction(lastKnownScrollPosition);
      ticking = false;
    });

    ticking = true;
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-v2"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".quote-container");
  const cards = container.children;
  const cardWidth = cards[0].offsetWidth + 64; // card width + left + right margin
  let isTransitioning = false;

  function updateCardOpacity() {
    Array.from(cards).forEach((card, index) => {
      card.classList.remove('active', 'dimmed');
      if (index === 1) { // center card is the second child (index 1)
        card.classList.add('active');
      } else {
        card.classList.add('dimmed');
      }
    });
  }

  function slideNext() {
    if (isTransitioning) return;
    isTransitioning = true;

    container.style.transition = "transform 0.5s ease";
    container.style.transform = `translateX(-${cardWidth}px)`;

    setTimeout(() => {
      container.appendChild(container.firstElementChild);
      container.style.transition = "none";
      container.style.transform = "translateX(0)";
      updateCardOpacity();
      isTransitioning = false;
    }, 500);
  }

  function slidePrev() {
    if (isTransitioning) return;
    isTransitioning = true;

    // Move last card to front instantly
    container.insertBefore(container.lastElementChild, container.firstElementChild);
    // Update opacity immediately
    updateCardOpacity();

    // Immediately shift container left (no transition)
    container.style.transition = "none";
    container.style.transform = `translateX(-${cardWidth}px)`;

    // Force reflow to apply styles immediately
    void container.offsetWidth;

    // Slide container back to position 0 with transition
    container.style.transition = "transform 0.5s ease";
    container.style.transform = "translateX(0)";

    setTimeout(() => {
      isTransitioning = false;
    }, 500);
  }

  document.querySelector(".right-arrow").addEventListener("click", slideNext);
  document.querySelector(".left-arrow").addEventListener("click", slidePrev);

  updateCardOpacity(); // initialize opacity on page load
});


  } catch(e) { console.error(e); }
})();
})();
